import React from 'react'
import MaterialSymbol from '../material-symbol'

const VisibilityOff = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="visibility_off" {...props} />
))

VisibilityOff.displayName = 'VisibilityOff'

export default VisibilityOff
